/** Exact money display — never round away cents (4.51 must stay $4.51). */
export function formatCurrency(amount: number): string {
  const value = Number.isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/** Compact chart labels (whole dollars / k / M). Handles negatives. */
export function formatK(value: number): string {
  const n = Number.isFinite(value) ? value : 0;
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${sign}$${Math.round(abs / 1_000)}k`;
  return formatCurrency(n);
}

export const chartMargins = {
  compact: { top: 8, right: 12, bottom: 8, left: 8 },
  labeled: { top: 12, right: 16, bottom: 28, left: 12 },
  donut: { top: 0, right: 0, bottom: 0, left: 0 },
} as const;
